import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {
  DynamicFormConfig,
  FieldTypeEnum,
  FilterSelectFieldConfig,
  LabelFieldConfig,
  OptionFieldConfig
} from '@mydocma/dynamic-form';
import {LayoutDuplicateMode} from './layout-duplicate-dialog.component';

export const DUPLICATE_MODE_FIELD_NAME = 'duplicateMode';
export const TYPE_FIELD_NAME = 'type';

@Injectable()
export class LayoutDuplicatDialogFormService {

  constructor(private readonly translateService: TranslateService) {
  }

  getFormConfig(
    duplicateMode: LayoutDuplicateMode,
    scopes: { id: number; text: string }[],
    selectedScopeId: number,
    isScopeForced: boolean
  ): DynamicFormConfig {
    const duplicateModeField = this.createDuplicateModeConfig(duplicateMode, isScopeForced);
    const typeField = this.createTypeConfig(scopes, selectedScopeId, duplicateMode);
    const typeLabelField = this.createTypeLabelField();

    const layout = {
      name: 'duplicateLayout',
      cols: [
        { col: 0, flex: 'auto' },
        { col: 1, flex: 'auto' }
      ],
      rows: [
        { row: 0 },
        { row: 1 }
      ],
      fields: [
        {
          fieldName: DUPLICATE_MODE_FIELD_NAME,
          col: 0,
          row: 0,
          colspan: 2,
          maxCollapsedWidth: 0,
          layoutAlign: 'start center'
        },
        {
          fieldName: 'typeLabel',
          col: 0,
          row: 1,
          maxCollapsedWidth: 0,
          layoutAlign: 'start center',
          flex: 'auto',
          class: 'type-label-with-offset'
        },
        {
          fieldName: TYPE_FIELD_NAME,
          col: 1,
          row: 1,
          maxCollapsedWidth: 0,
          layoutAlign: 'start center',
          flex: '70%',
        }
      ]
    };

    return {
      fields: [
        duplicateModeField,
        typeLabelField,
        typeField
      ],
      layouts: [layout]
    };
  }

  private createDuplicateModeConfig(duplicateMode: LayoutDuplicateMode, isScopeForced: boolean): OptionFieldConfig {
    return {
      id: DUPLICATE_MODE_FIELD_NAME,
      name: DUPLICATE_MODE_FIELD_NAME,
      label: {
        text: 'MM.layout.labelDuplicateMode'
      },
      type: FieldTypeEnum.option,
      orientation: 'vertical',
      options: [
        {
          optionLabel: this.translateService.instant('MM.layout.labelDuplicate'),
          optionValue: LayoutDuplicateMode.OnlyDuplicate.toString()
        },
        {
          optionLabel: this.translateService.instant('MM.layout.labelDuplicateAndChangeType'),
          optionValue: LayoutDuplicateMode.DuplicateAndChangeType.toString()
        }
      ],
      value: duplicateMode.toString(),
      readonly: isScopeForced
    };
  }

  private createTypeLabelField(): LabelFieldConfig {
    return {
      id: 'typeLabel',
      name: 'typeLabel',
      type: FieldTypeEnum.label,
      value: this.translateService.instant('MM.layout.labelDuplicateType')
    };
  }

  private createTypeConfig(
    scopes: { id: number; text: string }[],
    selectedScopeId: number,
    duplicateMode: LayoutDuplicateMode
  ): FilterSelectFieldConfig {
    const isReadonly = duplicateMode === LayoutDuplicateMode.OnlyDuplicate;

    return {
      id: TYPE_FIELD_NAME,
      name: TYPE_FIELD_NAME,
      label: {
        text: ''
      },
      type: FieldTypeEnum.filterSelect,
      required: false,
      source: scopes,
      value: selectedScopeId,
      removeClearButton: true,
      readonly: isReadonly
    };
  }
}
